import React, { useState } from "react";
import Base64ImageModal from "../../Components/ImageViewer/ImageViewer";

const LicenseDetailsView = ({ license }) => {
  // Calculate days pending for renewal
  const [openmd, setOpenmd] = useState(null);
  const calculateDaysPending = (nextRenewalDate) => {
    const today = new Date();
    const renewalDate = new Date(nextRenewalDate);
    const timeDifference = renewalDate - today;
    const daysPending = Math.ceil(timeDifference / (1000 * 60 * 60 * 24));
    return daysPending > 0 ? daysPending : 0;
  };

  const daysPending = calculateDaysPending(license.NextRenewalDate);

  // Handle view image button click
  const handleViewImage = () => {
    setOpenmd(true)
  };

  return (
    <div style={styles.container}>
      {/* <h2 style={styles.header}></h2> */}
      <div style={styles.detailsContainer}>
        <div style={styles.detailItem}>
          <span style={styles.label}>License Number:</span>
          <span style={styles.value}>{license.LicenseNO}</span>
        </div>
        <div style={styles.detailItem}>
          <span style={styles.label}>Driver Name:</span>
          <span style={styles.value}>{license.DriverName}</span>
        </div>
        <div style={styles.detailItem}>
          <span style={styles.label}>Next Renewal Date:</span>
          <span style={styles.value}>
            {new Date(license.NextRenewalDate).toLocaleDateString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </span>
        </div>
        <div style={styles.detailItem}>
          <span style={styles.label}>Days Pending Renewal:</span>
          <span
            style={{
              ...styles.value,
              color: daysPending <= 30 ? "#ef4444" : "#4ade80", // Red if <= 30 days, green otherwise
            }}
          >
            {daysPending} day(s)
          </span>
        </div>
        <div style={styles.detailItem}>
          <span style={styles.label}>Last Updated:</span>
          <span style={styles.value}>
            {new Date(license.DateUpdated).toLocaleString("en-US", {
              year: "numeric",
              month: "long",
              day: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })}
          </span>
        </div>
        <div style={styles.detailItem}>
          <button onClick={handleViewImage} style={styles.viewImageButton}>
            View License Image
          </button>
        </div>
      </div>
      <Base64ImageModal
        base64Image={license?.LicenseImage}
        name={license.FullName}
        open={openmd}
        onClose={() => setOpenmd(!openmd)}
      />
    </div>
  );
};

// Styles
const styles = {
  container: {
    maxWidth: "600px",
    margin: "0 auto",
    padding: "20px",
    border: "1px solid #e2e8f0",
    borderRadius: "8px",
    backgroundColor: "#f8fafc",
    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
  },
  header: {
    fontSize: "24px",
    fontWeight: "bold",
    color: "#1e293b",
    marginBottom: "20px",
    textAlign: "center",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
  },
  detailItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "10px",
    backgroundColor: "#ffffff",
    borderRadius: "6px",
    border: "1px solid #e2e8f0",
  },
  label: {
    fontSize: "16px",
    fontWeight: "500",
    color: "#475569",
  },
  value: {
    fontSize: "16px",
    fontWeight: "400",
    color: "#1e293b",
  },
  viewImageButton: {
    padding: "8px 16px",
    backgroundColor: "#3b82f6",
    color: "#ffffff",
    border: "none",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "14px",
    fontWeight: "500",
    transition: "background-color 0.2s",
  },
};

export default LicenseDetailsView;
